import React, { useState } from 'react'
import { LinearProgress } from '@material-ui/core'
import styled from '@emotion/styled'
import { colors } from '@workday/canvas-kit-react'

export type AutoRefreshLineProps = {
  refreshIntervalSeconds: number
  onRefresh: (completion: () => void) => void
  isSmallScreenWidth?: boolean
}

const MAX_UPDATES_PER_REFRESH = 20

const StyledLinearProgress = styled(LinearProgress)`
  height: ${(props) => '2px!important' };
  background-color: ${`${colors.frenchVanilla100}!important`};

  div {
    background-color: ${`${colors.blackPepper100}!important`};
  }
`

const AutoRefreshLine = ({ onRefresh, refreshIntervalSeconds, isSmallScreenWidth = false }: AutoRefreshLineProps) => {
  const secondsBetweenUpdates = Math.max(1, refreshIntervalSeconds / MAX_UPDATES_PER_REFRESH)
  const step = Math.max(100 / refreshIntervalSeconds, 100 / MAX_UPDATES_PER_REFRESH)

  const [progress, setProgress] = useState<number>(100)
  const [loadingNewContent, setLoadingNewContent] = useState(false)
  const refreshFeed = () => {
    setLoadingNewContent(true)
    onRefresh(() => {
      setLoadingNewContent(false)
      setProgress(100)
    })
  }

  React.useEffect(() => {
    const timer = setInterval(() => {
      setProgress(prev => {
        if (prev - step <= 0 && !loadingNewContent) {
          refreshFeed()
        }
        return prev - step
      })
    }, secondsBetweenUpdates * 1000)

    return () => {
      clearInterval(timer)
    }
  }, [])

  return (
    isSmallScreenWidth ? (
      <StyledLinearProgress variant="determinate" value={progress}/>
    ) : (
      <LinearProgress variant="determinate" value={progress}/>
    )
  )
}

export default AutoRefreshLine
